module.exports = __webpack_public_path__ + "f6603bb74046f9e490226f51fee294a8.pdf";